import {Box} from 'src/design/atoms/Box';
import React, {useState} from 'react';
import {DataHeader} from 'src/design/organisms/DataHeader';
import {useAlert} from 'src/shared/hooks/useAlert';

import type {AttachmentModuleEnum} from 'src/api/ProactApiClient';
import {useGetAttachmentListQuery} from 'src/redux/queries/attachment';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';
import {AttachmentForm} from './AttachmentForm';
import {AttachmentsList} from './AttachmentsList';

const maxPageRows = 10;
export interface AttachmentsModuleProps {
  entityId: number;
  attachmentType: AttachmentModuleEnum;
}

export const AttachmentsModule: React.FC<AttachmentsModuleProps> = ({
  entityId,
  attachmentType,
}) => {
  const {setAlert} = useAlert();
  const [currentPage, setCurrentPage] = useState<number>(1);

  const {data, isFetching, isError, error} = useGetAttachmentListQuery({
    start: (currentPage - 1) * maxPageRows,
    length: maxPageRows,
    attachmentType,
    entityId,
  });

  React.useEffect(() => {
    if (isError) {
      setAlert(parseErrorMessage(error), 'error');
    }
  }, [isError, error]);

  const handlePageChange = (
    _event: React.ChangeEvent<unknown>,
    value: number
  ) => setCurrentPage(value);

  return (
    <>
      <DataHeader
        titleText="Attachments"
        isFilterActive={false}
        titleSize="md"
      />
      <Box>
        <AttachmentForm
          mode="create"
          entityId={entityId}
          attachmentType={attachmentType}
          onSaved={() => {}}
          onCancelled={() => {}}
        />
      </Box>
      <Box style={{marginBottom: 240}}>
        <AttachmentsList
          entityId={entityId}
          attachmentType={attachmentType}
          isLoading={isFetching}
          data={data?.data ?? []}
          currentPage={currentPage}
          recordsPerPage={maxPageRows}
          totalRecords={data?.totalRecords ?? 0}
          onPageChange={handlePageChange}
          onInvalidateState={() => {}}
        />
      </Box>
    </>
  );
};
